module.exports = __webpack_public_path__ + "static/media/features-richmedia-full.5fc7ccad.png";